import React from 'react';
import { Navbar, Container, Button, Form, InputGroup, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSearch, faArrowUpShortWide, faArrowDownShortWide } from '@fortawesome/free-solid-svg-icons';

const MarketplaceHeader = ({ menuToggle, serverSideSearch, sortProducts, sortBy, sidebarHidden, storeName, brandLogo }) => {
  return (
    <Navbar 
      collapseOnSelect 
      expand="lg" 
      bg="primary" 
      variant="light" 
      className="shadow-sm py-2" 
      sticky="top"
      hidden={sidebarHidden}
    >
      <Container fluid="lg">
        <Navbar.Brand href="#home" className="me-3 text-white">
          <Image src={brandLogo} width={50} alt="Logo" className="me-3" /> <span className='font-bold'>{storeName} Marketplace</span>
        </Navbar.Brand>

        <Button 
          variant="outline-light" 
          onClick={menuToggle} 
          className="d-lg-none me-2"
          aria-label="Toggle menu"
        >
          <FontAwesomeIcon icon={faBars} />
        </Button>

        <Navbar.Toggle aria-controls="navbar-search" className="border-0 ms-auto" />

        <Navbar.Collapse id="navbar-search" className="order-lg-1 flex-grow-0">
          <div className="d-flex flex-column flex-lg-row align-items-center ms-lg-auto">
            <InputGroup className="mb-2 mb-lg-0 me-lg-2" style={{ width: '450px' }}>
              <InputGroup.Text className="bg-white border-end-0">
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
              <Form.Control
                type="search"
                placeholder="Search..."
                aria-label="Search"
                className="border-start-0"
                onKeyUp={serverSideSearch}
              />
            </InputGroup>

            <div className="d-flex">
              <Button
                variant={sortBy === 'desc' ? "light" : "primary"}
                className="me-2"
                onClick={() => sortProducts("desc")}
                aria-label="Sort descending"
                size="sm"
              >
                <FontAwesomeIcon icon={faArrowUpShortWide} />
              </Button>
              <Button
                variant={sortBy === 'asc' ? "light" : "primary"}
                onClick={() => sortProducts("asc")}
                aria-label="Sort ascending"
                size="sm"
              >
                <FontAwesomeIcon icon={faArrowDownShortWide} />
              </Button>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MarketplaceHeader;